module.exports = __webpack_public_path__ + "img/active-campaign.170ae0ac.png";